<template>
  <div class="row">
    <div ref="printFrom">
      <div v-loading="loadingApplication" element-loading-spinner="qc-spinner" class="col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">Application Details</h4>
        </div>
        <div class="card-content row ">
          <div class="form-horizontal">
          <div v-if="application">
              <dynamic-input 
                v-for="field in application.fields"
                :key="field.key"
                :name="field.key"
                :label="field.name" 
                :placeholder="field.name" 
                v-model="field.value" 
                :type="field.type"
                :readOnly="true" />
                <dynamic-input 
                v-if="!$store.state.isIndividual && application.customerReference"
                key="customerReference"
                name="customerReference"
                :label="$store.getters.appRefLabel" 
                placeholder="Reference" 
                v-model="application.customerReference" 
                type="TEXT"
                :readOnly="true" />
            </div>
          </div>        
        </div>
      </div>
          
      <div v-loading="loadingApplication || loadingVerifications > 0" element-loading-spinner="qc-spinner" class="col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">Verifications</h4>
          <div class="category">Verified qualifications included in the application.</div>
        </div>
        <div class="card-content row">
          <div v-if="application" class="form-group"> 
            <div v-if="builtVerifications.length < 1" class="col-md-12">
              <p>The applicant has not submitted any verifications yet.</p>
            </div>
            <div v-else v-for="verification, index in builtVerifications" :key="'OTHERWISE'+index">          
              <verification-result 
                :result="verification ? verification.result : null" 
                :notes="verification ? verification.notes : null" 
                :thirdPartyData="verification ? verification.thirdPartyData : null"
                :verification="verification"
                :showDocuments="false"
                :inApplication="true"
                style="padding-bottom: 20px"> 
              </verification-result>
            </div>
          </div>    
        </div>
      </div>
    </div>

    <div v-loading="loadingApplication" element-loading-spinner="qc-spinner" class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Documents</h4>
        <div class="category">Documents and evidence provided for the application, in addition to any documents provided for the verifications.</div>
      </div>
      <div v-if="!hasApplicationDocuments && !hasVerificationDocuments" class="card-content row">
        <div class="col-md-12">
          <p>The applicant has not submitted any documents yet.</p>
        </div>
      </div>
      <div v-else class="card-content row">
        <div v-if="application">
          <div class="row col-md-12">
            <div class="col-md-12">Application documents:</div></br></br>
            <document-card 
              v-if="document.id || document.data"
              v-for="document, index in application.documents" 
              :key="index" 
              :document="document"
              :canAdd="false"
              :canDelete="false" />
          </div>

          <div class="row col-md-12" v-for="verification in application.verifications"> 
            <div class="col-md-12">Verification {{formatName(verification)}} - {{formatInstituteName(verification)}} documents:</div></br></br>
            <document-card 
              v-for="document, index in verification.documents" 
              :key="index" 
              :document="document"
              :canAdd="false"
              :canDelete="false" />
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 card card-plain">
      <button v-if="application" @click.prevent="archive" v-bind:disabled="loadingApplication || loadingVerifications > 0 || downloading" v-bind:class="{'btn-disabled': loadingApplication || loadingVerifications > 0 || downloading}" class="btn btn-wd">
        <span class="btn-label"><i class="fa fa-folder-open-o"></i>&nbsp;Archive</span>
      </button>
      <button v-if="hasApplicationDocuments || hasVerificationDocuments" @click.prevent="download" v-bind:disabled="loadingApplication || loadingVerifications > 0 || downloading" v-bind:class="{'btn-disabled': loadingApplication || loadingVerifications > 0 || downloading}" class="btn btn-fill btn-wd pull-right">
        <i v-if="downloading" class="fa fa-cog fa-spin" aria-hidden="true"></i>
        <span v-else class="btn-label"><i class="fa fa-download"></i>&nbsp;Download All</span>
      </button>
    </div>

  </div>
</template>

<script>
  import DocumentInput from 'src/views/Verifications/components/DocumentInput'
  import DocumentCard from 'src/views/Verifications/components/DocumentCard'
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'

  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import VerificationResult from 'src/views/Verifications/components/Result'

  import { Loading } from 'element-ui'

  import moment from 'moment'
  
  export default {
    name: "application-result",
    components: {
      DynamicInput,
      DocumentInput,
      DocumentCard,
      'verification-result': VerificationResult
    },
    props: {
      id: String
    },
    data () {
      return {
        loadingApplication: false,
        loadingVerifications: 0,
        application: null,
        builtVerifications: [],
        downloading: false
      }
    },
    mounted: function () {
      var _this = this
      this.loadingApplication = true
      this.$api.getApplication(this.id)
        .then(response => {
          this.$service.buildApplicationDocuments(response.data)
          this.application = response.data
          this.loadingApplication = false
          
          if(this.application.verifications && this.application.verifications.length > 0) {
            this.loadingVerifications = this.application.verifications.length
            this.builtVerifications = []
            this.application.verifications.forEach((verification) => {
              this.$service.buildInstitute(verification.instituteId, verification)
                .then(response => {
                  var builtVerification = this.$service.buildVerification(verification)
                  builtVerification.institute = response
                  builtVerification.result = verification.result
                  builtVerification.notes = verification.notes
                  builtVerification.thirdPartyData = verification.fields['thirdPartyData']
                  this.builtVerifications.push(builtVerification)
                  this.loadingVerifications--
                })
                .catch(error => {
                  console.log(error)
                })

            }) 
          }
        })
        .catch(error => {
          console.log(error)
          this.loadingApplication = false
        })
    },
    computed: {
      verificationResults() {
      },
      hasApplicationDocuments() {
        if(this.application && this.application.documents && this.application.documents.length > 0) {
          for (var i = 0; i < this.application.documents.length; i++) {
            if(this.application.documents[i].id != null || this.application.documents[i].data != null) {
              return true
            }
          }
        }
        return false
      },
      hasVerificationDocuments() {
        if(this.application && this.application.verifications && this.application.verifications.length > 0) {
          for (var i = 0; i < this.application.verifications.length; i++) {
            var verification = this.application.verifications[i]
            if(verification.documents && verification.documents.length > 0) {
              for (var j = 0; j < verification.documents.length; j++) {
                if(verification.documents[i].id != null || verification.documents[i].data != null) {
                  return true
                }
              }
            }
          }
        }
        return false
      }
    },
    methods: {
      formatDate(date) {
        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      },
      formatName(verification) {
        return verification.fields.firstname + " " + verification.fields.surname
      },
      formatInstituteName(verification) {
        return verification.instituteNames && verification.instituteNames.length > 0 ? verification.instituteNames[0] : verification.instituteName
      },
      download () {
        this.downloading = true
        this.$api.downloadApplicationResult(this.application.id)
          .then(response => {        
            this.doDownload(response.headers['content-disposition'], new Blob([response.data], { type: 'application/octet-stream' }))
            this.downloading = false
          })
          .catch(error => {
            this.downloading = false
            console.log("Failed to download result")
            console.log(error)
          })
      },
      doDownload (filename, blob) {
        filename = filename.substring(filename.indexOf("=") + 1);
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(function(){
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100); 
        }
      },
      archive() {
        var appStatus = this.application.status// == 'COMPLETED'
        this.$modal.show(ModalOptions,
          {
            title: "Archive?",
            message: appStatus == 'COMPLETED' ? "Are you sure you want to archive this application?" : "This application is incomplete, are you sure you want to archive it?",
            message2: appStatus == 'COMPLETED' ? "This will also notify the applicant you have reviewed their application." : "This will notify the applicant you have closed their application.",
            closeText: "Cancel",
            actionText1: "Archive",
            closeAction: () => 
              {
                this.$modal.close()
              },
            action1: () => 
              {
                var loading = Loading.service({
                  spinner: 'qc-spinner',
                  text: 'Archiving...'
                })
                this.$modal.close()
                this.$api.updateApplication(this.application.id, {status:'ARCHIVED'})
                  .then(response => {
                    this.$router.push('/applicant/history')
                    loading.close()
                  })
                  .catch(error => {
                    loading.close()
                  })
              }
            })
      }
      // updateApplication() {
      //   this.loadingApplication = true
      //   this.$api.updateApplication(this.application.id, {fields: this.application.fields, documents: this.application.documents})
      //     .then(response => {
      //       this.$snotify.success("Application details saved.", "Success")
      //       this.application = response.data
      //       this.loadingApplication = false
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       this.loadingApplication = false
      //     })
      // }
    }
  }
</script>

<style>

</style>